import React from "react";
import { Box, Container, Typography, Link, useTheme } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";

const Footer: React.FC = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 6,
        backgroundColor: "background.paper",
        borderTop: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", gap: 2 }}>
            <Link
              href="http://linkedin.com/company/pyzon"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
              aria-label="Besuchen Sie unser LinkedIn-Profil"
              sx={{
                "&:hover": {
                  color: theme.palette.primary.main,
                },
                transition: "color 0.2s ease-in-out",
              }}
            >
              <LinkedInIcon />
            </Link>
            <Link
              href="https://instagram.com/pyzon.de"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
              aria-label="Besuchen Sie unser Instagram-Profil"
              sx={{
                "&:hover": {
                  color: theme.palette.primary.main,
                },
                transition: "color 0.2s ease-in-out",
              }}
            >
              <InstagramIcon />
            </Link>
          </Box>

          <Typography variant="body2" color="text.secondary">
            {currentYear} pyzon. Alle Rechte vorbehalten.
          </Typography>

          <Box sx={{ display: "flex", gap: 3 }}>
            <Link
              component={RouterLink}
              to="/imprint"
              color="inherit"
              aria-label="Zum Impressum"
              sx={{
                textDecoration: "none",
                "&:hover": {
                  color: theme.palette.primary.main,
                },
                transition: "color 0.2s ease-in-out",
              }}
            >
              Impressum
            </Link>
            <Link
              component={RouterLink}
              to="/privacy"
              color="inherit"
              aria-label="Zur Datenschutzerklärung"
              sx={{
                textDecoration: "none",
                "&:hover": {
                  color: theme.palette.primary.main,
                },
                transition: "color 0.2s ease-in-out",
              }}
            >
              Datenschutz
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
